import { render, staticRenderFns } from "./wallet-empty-state.vue?vue&type=template&id=0e999855&"
import script from "./wallet-empty-state.vue?vue&type=script&lang=js&"
export * from "./wallet-empty-state.vue?vue&type=script&lang=js&"
import style0 from "./wallet-empty-state.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e999855')) {
      api.createRecord('0e999855', component.options)
    } else {
      api.reload('0e999855', component.options)
    }
    module.hot.accept("./wallet-empty-state.vue?vue&type=template&id=0e999855&", function () {
      api.rerender('0e999855', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/wallet-empty-state/wallet-empty-state.vue"
export default component.exports